import { queryOptions } from '@tanstack/react-query';
import type { SelfEmployedListFilter } from '../lib/filters';
import { selfEmploymentApi, type OfdLogsFilter } from './self-employment-api';

/** Query-key factory; the re-check mutation invalidates through `lists()`. */
export const selfEmploymentKeys = {
  all: ['report-self-employment'] as const,
  lists: () => [...selfEmploymentKeys.all, 'list'] as const,
  list: (filter: SelfEmployedListFilter) =>
    [...selfEmploymentKeys.lists(), filter] as const,
  ofdLogs: (filter: OfdLogsFilter) =>
    [...selfEmploymentKeys.all, 'ofd-logs', filter] as const,
};

export const selfEmploymentQueries = {
  list: (filter: SelfEmployedListFilter) =>
    queryOptions({
      queryKey: selfEmploymentKeys.list(filter),
      queryFn: () => selfEmploymentApi.list(filter),
      refetchOnWindowFocus: false,
      placeholderData: (prev) => prev,
    }),

  /** Always refetched on open: a re-check may have just appended a log. */
  ofdLogs: (filter: OfdLogsFilter, enabled: boolean) =>
    queryOptions({
      queryKey: selfEmploymentKeys.ofdLogs(filter),
      queryFn: () => selfEmploymentApi.ofdLogs(filter),
      enabled,
      refetchOnMount: 'always',
      placeholderData: (prev) => prev,
    }),
};
